import { useUnit } from "effector-react"
import cn from "clsx"

import { mobileNavigationModel } from "../../models"
import { useMenuItems } from "../../shared/hooks"

import styles from "./navigation-mobile.module.pcss"

export const NavigationMobileToggle = () => {
  const isOpen = useUnit(mobileNavigationModel.$isOpen)
  const actions = useUnit({ toggle: mobileNavigationModel.toggle })
  const menuItems = useMenuItems()

  if (menuItems.length === 0) {
    return null
  }

  return (
    <button
      type="button"
      data-click-target-header-exclude
      className={cn(styles.mobileToggleButton, { [styles.active]: isOpen })}
      onClick={actions.toggle}
    >
      <div />
      <div />
      <div />
    </button>
  )
}
